import React from "react";
import Slider from "react-slick";
import "./Testimonials.css";
import TestimonialImage1 from "../../assets/TestimonialImage1.svg";
import TestimonialImage2 from "../../assets/TestimonialImage2.svg";
import TestimonialImage3 from "../../assets/TestimonialImage3.svg";
import { motion } from "framer-motion";

const Testimonials = () => {
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };

  const testimonials = [
    {
      id: 1,
      name: "Sarah Johnson",
      role: "Healthcare Professional",
      image: TestimonialImage1,
      rating: 5,
      review:
        "The first aid training was comprehensive and practical. The instructors were knowledgeable and made the learning experience engaging. I highly recommend this program to anyone looking to enhance their emergency response skills.",
    },
    {
      id: 2,
      name: "Michael Chen",
      role: "Safety Manager",
      image: TestimonialImage2,
      rating: 5,
      review:
        "Excellent training program! The hands-on approach and real-world scenarios prepared me well for emergency situations. The certification process was smooth and professional.",
    },
    {
      id: 3,
      name: "Emily Rodriguez",
      role: "School Teacher",
      image: TestimonialImage3,
      rating: 5,
      review:
        "Professional and thorough training. I feel confident in my ability to respond to emergencies thanks to this program. The materials were excellent and the instructors were patient and knowledgeable.",
    },
    {
      id: 4,
      name: "David Thompson",
      role: "Construction Worker",
      image: TestimonialImage1,
      rating: 5,
      review:
        "The workplace safety training was exactly what I needed. Clear instructions and practical skills that I use daily. This training has made me a more safety-conscious worker.",
    },
    {
      id: 5,
      name: "Lisa Wang",
      role: "Nurse",
      image: TestimonialImage2,
      rating: 5,
      review:
        "Outstanding training quality. The certification process was smooth and the materials were very helpful. I've already recommended this program to my colleagues.",
    },
  ];

  return (
    <div className="relative bg-gradient-to-br from-[#183864] via-[#1e4a73] to-[#2563eb] py-16 lg:py-20 overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 pointer-events-none">
        {/* Decorative pattern dots */}
        <div className="absolute top-0 left-0 w-full h-full opacity-5">
          <div className="grid grid-cols-12 gap-8 h-full w-full p-8">
            {[...Array(24)].map((_, i) => (
              <div key={i} className="w-2 h-2 bg-white rounded-full"></div>
            ))}
          </div>
        </div>
        <div className="absolute top-20 right-20 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-20 w-80 h-80 bg-[#B02526]/20 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 w-[90%] mx-auto">
        {/* Header Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 lg:mb-16"
        >
          <h2 className="text-4xl lg:text-5xl xl:text-6xl font-extrabold text-white mb-6">
            What Our Students Say
          </h2>
          <p className="text-xl lg:text-2xl text-white/80 max-w-3xl mx-auto leading-relaxed">
            Real feedback from professionals who have completed our training
            programs
          </p>

          {/* Stats */}
          <div className="flex justify-center gap-8 mt-8">
            <div className="text-center">
              <div className="text-3xl font-bold text-[#B02526]">500+</div>
              <div className="text-white/70 text-sm">Happy Students</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-[#B02526]">4.9</div>
              <div className="text-white/70 text-sm">Average Rating</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-[#B02526]">100%</div>
              <div className="text-white/70 text-sm">Satisfaction</div>
            </div>
          </div>
        </motion.div>

        {/* Testimonials Slider */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="testimonials-slider-modern"
        >
          <Slider {...settings}>
            {testimonials.map((testimonial, index) => (
              <div key={testimonial.id} className="px-4">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 border border-white/20 hover:bg-white/15 transition-all duration-300 transform hover:-translate-y-2 shadow-2xl"
                >
                  {/* Quote Icon */}
                  <div className="text-[#B02526] mb-6">
                    <svg
                      className="w-8 h-8"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-10zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h4v10h-10z" />
                    </svg>
                  </div>

                  {/* Review Text */}
                  <p className="text-white text-lg leading-relaxed mb-6 line-clamp-4">
                    "{testimonial.review}"
                  </p>

                  {/* Rating */}
                  <div className="flex items-center gap-1 mb-6">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <svg
                        key={i}
                        className="w-5 h-5 text-yellow-400"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                      </svg>
                    ))}
                  </div>
                </motion.div>
              </div>
            ))}
          </Slider>
        </motion.div>
      </div>
    </div>
  );
};

export default Testimonials;
